import { createTheme } from '@mui/material/styles';

// ============================================
// NARA Tourism — Tropical/Caribeño Theme
// Turquesa océano + Verde tropical + Arena dorada
// ============================================

export const NARA_COLORS = {
  primary: '#0891b2',
  primaryDark: '#155e75',
  primaryDeep: '#164e63',
  secondary: '#059669',
  secondaryDark: '#047857',
  accent: '#f59e0b',
  accentLight: '#fbbf24',
  background: '#f0fdfa',
  surface: '#ffffff',
  textPrimary: '#134e4a',
  textSecondary: '#64748b',
  border: '#e2e8f0',
  borderSubtle: '#ccfbf1',
};

export const NARA_GRADIENTS = {
  sidebar: 'linear-gradient(135deg, #164e63 0%, #0891b2 100%)',
  primary: 'linear-gradient(135deg, #0891b2 0%, #0e7490 100%)',
  login: 'linear-gradient(135deg, #164e63 0%, #0c4a6e 50%, #155e75 100%)',
  accent: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
  success: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
};

const naraTheme = createTheme({
  palette: {
    primary: { main: '#0891b2', dark: '#155e75', light: '#22d3ee' },
    secondary: { main: '#059669', dark: '#047857', light: '#34d399' },
    background: { default: '#f0fdfa', paper: '#ffffff' },
    text: { primary: '#134e4a', secondary: '#64748b' },
  },
  typography: {
    fontFamily: '"DM Sans", "Helvetica", "Arial", sans-serif',
    h1: { fontFamily: '"Outfit", sans-serif', fontWeight: 700 },
    h2: { fontFamily: '"Outfit", sans-serif', fontWeight: 700 },
    h3: { fontFamily: '"Outfit", sans-serif', fontWeight: 700 },
    h4: { fontFamily: '"Outfit", sans-serif', fontWeight: 600 },
    h5: { fontFamily: '"Outfit", sans-serif', fontWeight: 600 },
    h6: { fontFamily: '"Outfit", sans-serif', fontWeight: 600 },
  },
  shape: { borderRadius: 8 },
});

export default naraTheme;
